// Declare the build-time constant injected by Rollup
declare const __WIDGET_URL__: string;

/**
 * Get the widget URL.
 * 
 * Priority:
 * 1. Build-time constant (__WIDGET_URL__) - baked in during SDK build
 * 2. Fallback to production URL if constant is not replaced (e.g., in tests)
 */
export function getWidgetUrl(): string {
  // __WIDGET_URL__ is replaced at build time by Rollup
  // If it's not replaced (e.g., in tests), the typeof check will fail
  if (typeof __WIDGET_URL__ !== "undefined") {
    return __WIDGET_URL__;
  }

  // Fallback for tests or non-bundled environments
  return "https://widget.yampa.ai/latest/index.html";
}
